import Answers from './Answers';

export default Answers;
